import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
// import {api} from '../services/api';
import storageSession from "redux-persist/lib/storage/session";
import { Blog } from "../../types/type";

const persistConfig = {
  key: "root",
  version: 1,
  storage: storageSession,
  blacklist: [""],
};

interface MyState {
  isLoading: boolean;
  dashboardActive: string;
  isLoggedIn: any;
  loginPhone: any;
  category: any[];
  tripHistory: any[];
  withdrawalHistory: any[];
  withdrawalHistory2: any[];
  driverRating: any;
  //
  bankDetails: any;
  totalEarnings: number;
  isPin: boolean;
  selectedWithdrawBank: null;
  withdrawAmount: number;
  //
  userData: null;
  customers: any[];
  transactions: any[];
  providers: any[];
  agents: any[];
  orders: any[];
  newOrders: any[];
  notifications: any[];
  services: any[];
  categories: any[];
  faq: any[];
  customerOrders: any[];
  viewOrder: null;
  chats: any[];
  messages: any[];
  supportUser: null;
  userTransactions: any[];
  notificationModal: boolean;
  privacyPolicy: null;
  providersInReview: any[];
  viewProviderInReview: null;
  viewCustomer: null;
  viewWallet: null;
  referrals: any[];
  lessThanTwoStars: any[];
  blogs: Blog[];
  alltransactions: any[];
  allwithdrawals: any[];
  viewAgent: null;
  referralsByUser: any[];
}

const initialState: MyState = {
  dashboardActive: "",
  isLoading: false,
  isLoggedIn: null,
  loginPhone: null,
  category: [],

  bankDetails: null,
  tripHistory: [],
  withdrawalHistory: [],
  withdrawalHistory2: [],
  driverRating: null,
  totalEarnings: 0,
  isPin: false,
  selectedWithdrawBank: null,
  withdrawAmount: 0,

  //
  userData: null,
  customers: [],
  viewCustomer: null,
  transactions: [],
  providers: [],
  agents: [],
  orders: [],
  newOrders: [],
  services: [],
  categories: [],
  notifications: [],
  faq: [],
  customerOrders: [],
  viewOrder: null,
  chats: [],
  messages: [],
  supportUser: null,
  userTransactions: [],
  notificationModal: false,
  privacyPolicy: null,
  providersInReview: [],
  viewProviderInReview: null,
  viewWallet: null,
  referrals: [],
  lessThanTwoStars: [],
  blogs: [],
  alltransactions: [],
  allwithdrawals: [],
  viewAgent: null,
  referralsByUser: [],
};

export const mainSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    authPhone: (state, action: PayloadAction<any>) => {
      console.log("here", action.payload);
      state.loginPhone = { phone: action.payload };
    },
    loggedIn: (state, action) => {
      // `authenticated`, not a token. The session is an httpOnly cookie the
      // browser holds and this code cannot read, so there is no token here to
      // key on. This used to store `token: action.payload.token`; once the API
      // stopped returning one, the route guard's `loggedIn.token` check failed
      // and a successful login bounced straight back to the login page.
      //
      // This flag is a UI hint, never proof: the cookie is the real credential,
      // and a stale flag just means one API call 401s and redirects.
      state.isLoggedIn = {
        authenticated: true,
        userType: action.payload.type,
      };
      state.loginPhone = action.payload.phone;
    },
    logout: (state) => {
      state.isLoggedIn = null;
    },
    // removeCategory: (state, action) => {
    //   var arr = state.category.filter(text => text !== action.payload);
    //   state.category = arr;
    // },
    //------------------->>>>>>
    getData: (state, action) => {
      state.userData = action.payload;
    },
    //------------------->>>>>>
    // addprofileCompleted: (state, action) => {
    //   console.log('profile dispatch here', action.payload);
    //   state.profileCompleted = action.payload;
    // },
    addbankDetails: (state, action) => {
      console.log("bankDetails here", action.payload);
      state.bankDetails = action.payload;
    },
    addtripHistory: (state, action) => {
      console.log("addtripHistory here", action.payload);
      state.tripHistory = action.payload;
    },
    addwithdrawalHistory: (state, action) => {
      console.log("addwithdrawalHistory here", action.payload);
      state.withdrawalHistory = action.payload;
    },
    addwithdrawalHistory2: (state, action) => {
      console.log("addwithdrawalHistory2 here", action.payload);
      state.withdrawalHistory2 = action.payload;
    },
    adddriverRating: (state, action) => {
      console.log("adddriverRating here", action.payload);
      state.driverRating = action.payload;
    },
    addtotalEarnings: (state, action) => {
      console.log("addtotalEarnings here", action.payload);
      state.totalEarnings = action.payload;
    },
    addwithdrawHistory: (state, action) => {
      console.log("addwithdrawHistory here", action.payload);
      state.totalEarnings = action.payload;
    },
    addisPin: (state, action) => {
      console.log("isPin here", action.payload);
      state.isPin = action.payload;
    },
    addselectedWithdrawBank: (state, action) => {
      console.log("addselectedWithdrawBank", action.payload);
      state.selectedWithdrawBank = action.payload;
    },
    addwithdrawAmount: (state, action) => {
      console.log("addwithdrawAmount", action.payload);
      state.withdrawAmount = action.payload;
    },
    //
    adduserData: (state, action) => {
      console.log("adduserData", action.payload);
      state.userData = action.payload;
    },
    addcustomers: (state, action) => {
      console.log("addcustomers", action.payload);
      state.customers = action.payload;
    },
    addproviders: (state, action) => {
      console.log("addproviders", action.payload);
      state.providers = action.payload;
    },
    addtransactions: (state, action) => {
      console.log("addtransactions", action.payload);
      state.transactions = action.payload;
    },
    addorders: (state, action) => {
      console.log("addorders", action.payload);
      state.orders = action.payload;
    },
    addNewOrders: (state, action) => {
      console.log("add new orders", action.payload);
      state.newOrders = action.payload;
    },
    addservices: (state, action) => {
      console.log("addservices", action.payload);
      state.services = action.payload;
    },
    addcategories: (state, action) => {
      console.log("addcategories", action.payload);
      state.categories = action.payload;
    },
    addnotifications: (state, action) => {
      console.log("addnotifications", action.payload);
      state.notifications = action.payload;
    },
    addfaq: (state, action) => {
      console.log("addfaq", action.payload);
      state.faq = action.payload;
    },
    addisLoading: (state, action) => {
      console.log("addisLoading", action.payload);
      state.isLoading = action.payload;
    },
    adddashboardActive: (state, action) => {
      console.log("adddashboardActive", action.payload);
      state.dashboardActive = action.payload;
    },
    addcustomerOrders: (state, action) => {
      console.log("addcustomerOrders", action.payload);
      state.customerOrders = action.payload;
    },
    addviewOrder: (state, action) => {
      console.log("addviewOrder", action.payload);
      state.viewOrder = action.payload;
    },
    addchats: (state, action) => {
      console.log("addchats", action.payload);
      state.chats = action.payload;
    },
    addmessages: (state, action) => {
      console.log("addmessages", action.payload);
      state.messages = action.payload;
    },
    addagents: (state, action) => {
      console.log("addagents", action.payload);
      state.agents = action.payload;
    },
    addsupportUser: (state, action) => {
      console.log("addsupportUser", action.payload);
      state.supportUser = action.payload;
    },
    adduserTransactions: (state, action) => {
      console.log("adduserTransactions", action.payload);
      state.userTransactions = action.payload;
    },
    addnotificationModal: (state, action) => {
      console.log("addnotificationModal", action.payload);
      state.notificationModal = action.payload;
    },
    addPrivacyPolicy: (state, action) => {
      console.log("addPrivacyPolicy", action.payload);
      state.privacyPolicy = action.payload;
    },
    addprovidersInReview: (state, action) => {
      console.log("addprovidersInReview", action.payload);
      state.providersInReview = action.payload;
    },
    addviewProviderInReview: (state, action) => {
      console.log("addviewProviderInReview", action.payload);
      state.viewProviderInReview = action.payload;
    },
    addviewCustomer: (state, action) => {
      console.log("addviewCustomer", action.payload);
      state.viewCustomer = action.payload;
    },
    addviewWallet: (state, action) => {
      console.log("addviewWallet", action.payload);
      state.viewWallet = action.payload;
    },
    addreferral: (state, action) => {
      console.log("addreferral", action.payload);
      state.referrals = action.payload;
    },
    addlessThanTwoStar: (state, action) => {
      console.log("addlessThanTwoStar", action.payload);
      state.lessThanTwoStars = action.payload;
    },
    addBlog: (state, action) => {
      state.blogs = action.payload;
    },
    addAllTransactions: (state, action) => {
      state.alltransactions = action.payload;
    },
    addAllWithdrawals: (state, action) => {
      state.allwithdrawals = action.payload;
    },
    viewAgent: (state, action) => {
      state.viewAgent = action.payload;
    },
    addreferralsByUser: (state, action) => {
      state.referralsByUser = action.payload;
    },
  },
});

export const {
  authPhone,
  loggedIn,
  logout,
  addbankDetails,
  addtripHistory,
  addwithdrawalHistory,
  addwithdrawalHistory2,
  adddriverRating,
  addtotalEarnings,
  addisPin,
  addselectedWithdrawBank,
  addwithdrawAmount,
  //
  adduserData,
  addcustomers,
  addproviders,
  addtransactions,
  addorders,
  addNewOrders,
  addservices,
  addcategories,
  addnotifications,
  addfaq,
  addisLoading,
  adddashboardActive,
  addcustomerOrders,
  addviewOrder,
  addchats,
  addmessages,
  addagents,
  addsupportUser,
  adduserTransactions,
  addnotificationModal,
  addPrivacyPolicy,
  addprovidersInReview,
  addviewProviderInReview,
  addviewCustomer,
  addviewWallet,
  addreferral,
  addlessThanTwoStar,
  addBlog,
  addAllTransactions,
  addAllWithdrawals,
  viewAgent,
  addreferralsByUser,
} = mainSlice.actions;

const mainReducer = persistReducer(persistConfig, mainSlice.reducer);
export default mainReducer;
